export default {
  tags: {
    preferred: 'Preferito',
  },
};
